import { Formik, Form } from "formik";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TextBox from "./form/TextBox";
import * as Yup from "yup";

const ConfirmationPrompt = ({
    show,
    message = "OTM_PROCEED_?",
    showConfirm = true,
    onConfirm,
    onCancel,
    disabled = false,
    manualInput = false,
    manualInputText = 'permanently delete',
    identifier = "",
    renderButtons = () => {}
}) => {
    const [translate] = useTranslation();

    return <Formik
        key={show ? "modal-open" : "modal-closed"}
        initialValues={{
            text: ''
        }}
        validationSchema={Yup.object({
            text: Yup.string().oneOf([manualInputText], "").required(""),
        })}
        onSubmit={() => onConfirm(identifier)}
        validateOnMount
        enableReinitialize
    >
        {(props) => <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_CONFIRM")}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <Form id="confirmationPrompt">
                    <label>{translate(message)}</label>
                    {manualInput && <>
                        <label className="mt-3">{translate("OTM_TYPE_FOLLOWING_TEXT_TO_CONFIRM", { manualInput: manualInputText })}</label>
                        <TextBox name="text" size="sm" placeholder={manualInputText} />
                    </>}
                </Form>
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                {renderButtons()}
                {showConfirm && <Button
                    form="confirmationPrompt"
                    disabled={disabled || (manualInput && !props.isValid)}
                    onClick={() => onConfirm(identifier)}
                    variant="primary"
                    className="btn-sm">
                    {translate("OTM_CONFIRM")}
                </Button>}
                <Button
                    disabled={disabled}
                    onClick={onCancel}
                    variant="secondary"
                    className="btn-sm">
                    {translate("OTM_CANCEL")}
                </Button>
            </BootstrapModal.Footer>
        </BootstrapModal>}
    </Formik>
};

export default ConfirmationPrompt;